// Invoice statuses of the bookkeeping module plus the legacy labels of old documents.
export const invoiceStatusArray = [
  { status: "draft", color: "#6B7280", tag: "default", label: "Draft" },
  { status: "sent", color: "#3B82F6", tag: "blue", label: "Sent" },
  { status: "partially_paid", color: "#0EA5E9", tag: "cyan", label: "Partially paid" },
  { status: "paid", color: "#22C55E", tag: "green", label: "Paid" },
  { status: "overdue", color: "#F59E0B", tag: "gold", label: "Overdue" },
  { status: "reminded_1", color: "#F97316", tag: "orange", label: "1st reminder" },
  { status: "reminded_2", color: "#EA580C", tag: "volcano", label: "2nd reminder" },
  { status: "reminded_3", color: "#DC2626", tag: "red", label: "Final reminder" },
  { status: "handed_over", color: "#7F1D1D", tag: "magenta", label: "Handed over" },
  {
    status: "partially_written_off",
    color: "#B45309",
    tag: "warning",
    label: "Partially written off"
  },
  { status: "written_off", color: "#78350F", tag: "error", label: "Written off" },
  // Abschlag closed by its Schlussrechnung
  { status: "settled", color: "#15803D", tag: "success", label: "Settled" },
  { status: "cancelled", color: "#9CA3AF", tag: "default", label: "Cancelled" },
  // legacy labels
  { status: "In Control", color: "#000", tag: "default", label: "Draft" },
  { status: "Pending", color: "#FACC15", tag: "default", label: "Draft" },
  { status: "Partially Paid", color: "#3B82F6", tag: "cyan", label: "Partially paid" },
  { status: "1st Warning", color: "#F97316", tag: "orange", label: "1st reminder" },
  { status: "2nd Warning", color: "#DC2626", tag: "volcano", label: "2nd reminder" },
  { status: "Fully Paid", color: "#22C55E", tag: "green", label: "Paid" }
];

const LEGACY = {
  "in control": "draft",
  pending: "draft",
  "partially paid": "partially_paid",
  "fully paid": "paid",
  "1st warning": "reminded_1",
  "2nd warning": "reminded_2"
};

/** Legacy label → new status key ("In Control" → "draft"). */
export const normalizeInvoiceStatus = status => {
  const key = String(status || "")
    .trim()
    .toLowerCase();
  return LEGACY[key] || key || "draft";
};

export const invoiceStatusMeta = status =>
  invoiceStatusArray.find(s => s.status === normalizeInvoiceStatus(status)) ||
  invoiceStatusArray[0];

export const invoiceTypeLabels = {
  invoice: "Invoice",
  partial: "Partial invoice",
  advance: "Advance invoice",
  final: "Final invoice",
  credit_note: "Invoice correction",
  cancellation: "Cancellation invoice",
  correction_notice: "Correction notice"
};

/** Types that correct another document and carry no receivable of their own. */
export const DOCUMENT_ONLY_TYPES = ["credit_note", "cancellation", "correction_notice"];

/** Documents whose amounts reduce the customer's debt (shown negative in lists). */
export const NEGATIVE_TYPES = ["credit_note", "cancellation"];

/** Customer credit (Kundenguthaben) statuses. */
export const creditStatusMeta = {
  open: { tag: "processing", label: "Credit open" },
  used: { tag: "default", label: "Credit used" },
  refund_pending: { tag: "warning", label: "Refund pending" },
  void: { tag: "default", label: "Credit void" }
};

/** Reason picklist of a Rechnungskorrektur (GS-2). */
export const correctionReasonLabels = {
  defect: "Defects / price reduction",
  return: "Return of goods",
  goodwill: "Goodwill",
  price_error: "Wrong price",
  quantity_error: "Wrong quantity",
  bonus: "Bonus / discount",
  other: "Other reason"
};

/** Payment methods outside bank matching (PAY-1). */
export const paymentMethodLabels = {
  bank: "Bank transfer",
  cash: "Cash",
  card: "Debit / credit card",
  paypal: "PayPal",
  cheque: "Cheque",
  direct_debit: "Direct debit",
  offset: "Offset with credit",
  other: "Other"
};

/** Forderungsausfall reasons (FA-1). */
export const writeOffReasonLabels = {
  insolvency: "Insolvency",
  unreachable: "Customer unreachable",
  time_barred: "Time-barred",
  settlement: "Settlement (Vergleich)",
  other: "Other reason"
};

/** § 35a EStG cost type of a line (PA-2). */
export const costTypeLabels = {
  labour: "Labour",
  material: "Material",
  machine: "Machine costs",
  travel: "Travel costs",
  other: "Other"
};

const LABOUR_UNITS = ["h", "std", "std.", "stunde", "stunden", "hour", "hours", "min", "minute"];

/** Default cost type of a line from its unit, like the server: hours → labour, else material. */
export const defaultCostType = unit =>
  LABOUR_UNITS.includes(
    String(unit || "")
      .trim()
      .toLowerCase()
  )
    ? "labour"
    : "material";

export const taxModeLabels = {
  regular: "Regular VAT (19 % / 7 %)",
  small_business: "Small business (§ 19 UStG, no VAT)",
  reverse_charge: "Reverse charge (§ 13b UStG)",
  intra_eu: "Intra-EU supply (tax-free)",
  eu_services: "EU services (reverse charge)",
  exempt: "Tax exempt (§ 4 UStG)"
};
